export enum NRIDataCategory {
  HURRICANES = "hurricanes",
  TORNADOES = "tornadoes",
  COASTAL_FLOODING = "coastal_flooding",
  DROUGHTS = "droughts",
  COLD_WAVE = "cold_wave",
  EARTHQUAKES = "earthquakes",
  HAIL = "hail",
  HEAT_WAVES = "heat_waves",
  ICE_STORM = "ice_storm",
  LANDSLIDES = "landslides",
  RIVERINE_FLOODING = "riverine_flooding",
  STRONG_WINDS = "strong_winds",
  WINTER_WEATHER = "winter_weather",
  WILDFIRES = "wildfires",
}

export enum NRIDataCategoryPrefix {
  HURRICANES = "HRCN",
  TORNADOES = "TRND",
  COASTAL_FLOODING = "CFLD",
  DROUGHTS = "DRGT",
  COLD_WAVE = "CWAV",
  EARTHQUAKES = "ERQK",
  HAIL = "HAIL",

  HEAT_WAVES = "HWAV",
  ICE_STORM = "ISTM",
  LANDSLIDES = "LNDS",
  RIVERINE_FLOODING = "RFLD",
  STRONG_WINDS = "SWND",
  WINTER_WEATHER = "WNTW",
  WILDFIRES = "WFIR",
}

export function getFeatureUrl(category: NRIDataCategory) {
  switch (category) {
    case NRIDataCategory.DROUGHTS:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Drought/FeatureServer/1";
    case NRIDataCategory.EARTHQUAKES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Earthquake/FeatureServer/1";
    case NRIDataCategory.RIVERINE_FLOODING:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Riverine_Flooding/FeatureServer/1";
    case NRIDataCategory.TORNADOES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Tornado/FeatureServer/1";
    case NRIDataCategory.WILDFIRES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Wildfire/FeatureServer/1";
    case NRIDataCategory.COASTAL_FLOODING:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Coastal_Flooding/FeatureServer/1";
    case NRIDataCategory.LANDSLIDES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Landslide/FeatureServer/1";
    case NRIDataCategory.WINTER_WEATHER:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Winter_Weather/FeatureServer/1";
    case NRIDataCategory.HURRICANES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Hurricane/FeatureServer/1";
    case NRIDataCategory.ICE_STORM:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Ice_Storm/FeatureServer/1";
    case NRIDataCategory.HAIL:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Hail/FeatureServer/1";
    case NRIDataCategory.COLD_WAVE:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Cold_Wave/FeatureServer/1";
    case NRIDataCategory.STRONG_WINDS:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Strong_Wind/FeatureServer/1";
    case NRIDataCategory.HEAT_WAVES:
      return "https://services.arcgis.com/XG15cJAlne2vxtgt/arcgis/rest/services/National_Risk_Index_Annualized_Frequency_Heat_Wave/FeatureServer/1";
    default:
      return "";
  }
}
